import PropTypes from 'prop-types'
import './SubTitle.css'

export default function SubTitle({ items }) {
  if (!items || items.length === 0) return null
  
  return (
    <div className="subtitle-container">
      <div className="subtitle-wrapper">
        <div className="subtitle-content">
          {items.map((item, index) => (
            <div key={index} className="subtitle-row">
              <span className="subtitle-label">{item.label}</span>
              <span className="subtitle-value">{item.value}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

SubTitle.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    })
  ).isRequired
}
